module.exports = __webpack_public_path__ + "img/web_lib_statistic_1.d52f0f9a.jpg";